import React from 'react';
import styles from './Banner.module.scss';
import me from 'assets/me.png';
import map from 'assets/map.png';
import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai';
import Skills from './Skills/Skills';


const Banner = () => {
    return (
        <section id="banner" className={styles.banner}>
            <div className={styles.container}>
                <div className={styles["text-container"]}>
                    <h1>Front-End React Developer</h1>
                    <p>Hello! I am Ubergue De Andrade, a passionate Front-End React Developer based in  Dublin, Ireland. <img src={map} alt="Map Icon"/></p>
                    <div className={styles.social}>
                        <a href="https://www.linkedin.com/in/ubergue/" target='blank'><AiFillLinkedin /></a>
                        <a href="https://github.com/bergjr" target='blank'><AiFillGithub /></a>
                    </div>
                    <Skills />
                </div>
                <div className={styles["photo-container"]}>
                    <img src={me} className={styles.me} alt="myself" />
                </div>
            </div>
        </section>
    );
}

export default Banner;
